/**
 * @generated SignedSource<<861e67cb30dde4938392a9f07f4fa5c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TranslatableTextFieldTranslateButton_data$data = {
  readonly translateTextTranslation?: string | null;
  readonly " $fragmentType": "TranslatableTextFieldTranslateButton_data";
};
export type TranslatableTextFieldTranslateButton_data$key = {
  readonly " $data"?: TranslatableTextFieldTranslateButton_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranslatableTextFieldTranslateButton_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "id"
    },
    {
      "kind": "RootArgument",
      "name": "to"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "translate"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": require('./TranslatableTextFieldTranslateButtonRefetchQuery.graphql')
    }
  },
  "name": "TranslatableTextFieldTranslateButton_data",
  "selections": [
    {
      "condition": "translate",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "id",
              "variableName": "id"
            },
            {
              "kind": "Variable",
              "name": "to",
              "variableName": "to"
            }
          ],
          "kind": "ScalarField",
          "name": "translateTextTranslation",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "b941093e2a770d34300694c407fd9fec";

export default node;
